import Shared from '../Shared.js';
import { PortalType } from '../Helpers/PortalType';
import { DataStorage } from '@studyportals/data-storage';

const environment = Shared.live === true ? 'prd' : 'tst';

const tracker = new window.SPTracker({
	environment: environment,
	team: 'spc',
	product: 'Study',
	category: 'PremiumClick'
});

class PremiumClickPerformanceTracking {
	constructor() {
		this.elements = [];
		document.addEventListener('premium_click_tracker_update_listeners', () => this.attachEventListeners());
	}

	attachEventListeners() {
		document.querySelectorAll('.TrackingExternalLink').forEach((element) => {
			if (this.elements.includes(element)) {
				return;
			}
			this.elements.push(element);

			element.addEventListener('click', function (e) {
				let tags = e.target.className.split(' ');
				if (e.target.dataset['gaTracking']) {
					const gaData = JSON.parse(e.target.dataset['gaTracking']);
					tags.push(gaData.value);
				}

				if (PortalType) {
					tags.push(PortalType.getCurrentPortal());
				}

				const trafficSourceData = DataStorage.retrieve('traffic_source');
				if (trafficSourceData && trafficSourceData.utm_source?.source) {
					tags.push(`TrafficSource:${trafficSourceData.utm_source.source}`);
				}

				tracker.track({
					tags: tags,
					action: 'Click',
					label: 'ReferrerButton'
				});
			});
		});
	}
}

const tracking = new PremiumClickPerformanceTracking();
tracking.attachEventListeners();
